import * as preact from 'preact'
const { h, Component } = preact
import * as styles from './style.css'
import { Paragraph } from '@nrk/dh-feature-components'
import classNames from 'classnames'
import PureComponent from '../../../lib/preact-pure-component'

interface Props {
  text?: string
  id: string
  style?: string
  active: boolean
  source?: string
  preload: boolean
  backgroundType: string
  shadowColor: string
  noShadow: boolean
}

export class Text extends PureComponent<Props, {}> {
  shadowMaker(shadowColor: string) {
    const color = shadowColor || '0, 0, 0'
    const alphaFrom = 0
    const alphaTo = 0.6
    const diff = alphaFrom - alphaTo
    const gradient = `linear-gradient(rgba(${color}, ${alphaFrom}) 0%,
      rgba(${color}, ${alphaFrom - diff * 0.85}) 32.500%,
      rgba(${color}, ${alphaFrom - diff * 0.925}) 37.750%,
      rgba(${color}, ${alphaFrom - diff * 0.963}) 41.425%,
      rgba(${color}, ${alphaFrom - diff * 0.981}) 44.000%,
      rgba(${color}, ${alphaTo}) 50%,
      rgba(${color}, ${alphaFrom - diff * 0.981}) ${100 - 44.0}%,
      rgba(${color}, ${alphaFrom - diff * 0.963}) ${100 - 41.425}%,
      rgba(${color}, ${alphaFrom - diff * 0.925}) ${100 - 37.75}%,
      rgba(${color}, ${alphaFrom - diff * 0.85}) ${100 - 32.5}%,
      rgba(${color}, ${alphaFrom - diff * 0.7}) ${100 - 25.0}%,
      rgba(${color}, ${alphaFrom}) 100%
    )`

    return gradient
  }

  getShadowStyle = () => {
    if (typeof window !== 'undefined' && window.matchMedia('(max-aspect-ratio: 1/1) and (max-width: 750px)').matches) {
      const gradientShadow = this.shadowMaker(this.props.shadowColor)
      return {
        backgroundImage: gradientShadow,
        backgroundColor: 'transparent'
      }
    }
    return {
      backgroundColor: `rgba(${this.props.shadowColor}, 0.6)`,
      backgroundImage: 'none'
    }
  }

  render() {
    const { style, preload, noShadow, backgroundType, shadowColor, text } = this.props

    const classNameWrapper = classNames(styles.textwrapper, {
      [styles.loaded]: preload && backgroundType !== 'black',
      [styles.prologue]: style && style.indexOf('prologue') > -1,
      [styles.center]: style && style.indexOf('center') > -1,
      [styles.green]: style && style.indexOf('green') > -1,
      [styles.nomargintop]: style && style.indexOf('nomargintop') > -1
    })

    const classNameText = classNames(styles.text, {
      [styles.textLoaded]: preload
    })

    const classNameTextShadow = classNames({
      [styles.textShadow]: !noShadow
    })

    const noPrologueDesktopShadow =
      style &&
      style.indexOf('prologue') > -1 &&
      typeof window !== 'undefined' &&
      window.matchMedia('(min-width: 750px)').matches
    const shadowStyle = preload && shadowColor && !noShadow && !noPrologueDesktopShadow ? this.getShadowStyle() : null

    return (
      <div className={classNameWrapper}>
        <div className={classNameTextShadow} style={shadowStyle} />
        <Paragraph html={text} className={classNameText} />
      </div>
    )
  }
}
